module.exports = __webpack_public_path__ + "img/tel.bce9f0e7.png";